import MerchantSettingsPage from '../../../components/merchant/settings/MerchantSettingsPage'

export default function Settings() {
  return <MerchantSettingsPage />
}
